import React from "react";

const LogoSmall = () => (
<svg width="38" height="41" viewBox="0 0 38 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 40.8346V0H37.649V40.8346H0ZM1.43824 1.43372V39.405H36.2067V1.43372H1.43824Z" fill="#00F37A" className="square-1 color-palette-fill"/>
<path d="M32.9528 36.1548H12.2422V7.48438H32.9528V36.1548ZM13.6845 34.7211H31.5105V8.9181H13.6845V34.7251V34.7211Z" fill="#00F37A" className="square-2 color-palette-fill"/>
<path d="M28.2711 31.4875H19.3828V17.9141H28.2711V31.4875ZM20.8252 30.0537H26.8329V19.3437H20.8252V30.0537Z" fill="#00F37A" className="square-3 color-palette-fill"/>
</svg>
);

export default LogoSmall;
